export const AMOUNT_KEY = 'controlValues.amount';
export const UNIT_KEY = 'controlValues.unit';
export const CRON_KEY = 'controlValues.cron';
export const TYPE_KEY = 'controlValues.type';
